import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { Moment } from 'moment';
import { Subject, Subscription } from 'rxjs';

import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { Store } from '@ngrx/store';
import { AppState } from '@app/state/app.state';
import { quoteConfigurationSelector, quoteSelector } from '@app/state/app.selectors';
import { QuotingModuleState } from '@quoting/state/quoting-module.state';
import { SetQuoteConfiguration } from '@quoting/state/actions/quoting-module.actions';
import { QuoteConfiguration } from '@app/shared/models/customer-details';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-new-contract-start-month-input',
  templateUrl: './new-contract-start-month-input.component.html',
  styleUrls: ['./new-contract-start-month-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NewContractStartMonthInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NewContractStartMonthInputComponent),
      multi: true,
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class NewContractStartMonthInputComponent implements OnInit, ControlValueAccessor, Validator, OnDestroy {

  public frmNewContractStartMonth: FormGroup;
  private updated = new Subject<any>();
  register$: Subscription;
  public onTouched: () => void = () => {};
  selectQuote$: Subscription;

  newContractStartMonth = new FormControl(moment(), Validators.required);
  quoteConfiguration$: Subscription;
  quoteConfiguration: QuoteConfiguration;

  constructor(private store: Store<AppState>) { }

  ngOnInit(): void {
    this.selectQuote$ = this.store.select(quoteSelector).subscribe((quote) => {
      this.setupForm(quote);
    });

    this.quoteConfiguration$ = this.store.select(quoteConfigurationSelector).subscribe((quoteConfiguration) => {
      this.quoteConfiguration = quoteConfiguration;
    });
  }

  ngOnDestroy(): void {
    this.register$?.unsubscribe();
    this.selectQuote$?.unsubscribe();
    this.quoteConfiguration$?.unsubscribe();
  }

  public onChange(oc: any) {

  }

  public shouldShowUnfocusedDescription(): boolean {
    return true;
  }

  public getEventValue = (event: any) => {
    const newDate = event?.value?.format("YYYY-MM-DD") ?? '';
    return newDate;
  };

  get minDate() {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth());
  }

  get maxDate () {
    return;
  };

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.newContractStartMonth?.value;// ?? moment();
    ctrlValue.date(1);
    ctrlValue.month(+moment(normalizedMonth).format("M") - 1);
    ctrlValue.year(moment(normalizedMonth).format("Y"))
    this.frmNewContractStartMonth.get('newContractStartMonth').setValue(ctrlValue);
    datepicker.close();

    const quoteConfigUpdate = { ...this.quoteConfiguration, newContractStartMonth: this.newContractStartMonth?.value };
    this.store.dispatch(new SetQuoteConfiguration(this.quoteConfiguration?.quoteRequestId, quoteConfigUpdate));
  }

  writeValue(val: any): void {
    if (val) {
      this.frmNewContractStartMonth.patchValue(val, { emitEvent: false });
    }
    this.updated.next('form');
  }

  registerOnChange(fn: any): void {
    this.register$ = this.frmNewContractStartMonth.valueChanges.subscribe((x) =>
      fn(this.frmNewContractStartMonth.getRawValue())
    );
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): ValidationErrors {
    if(control.errors) {
      this.frmNewContractStartMonth.get('newContractStartMonth').markAsTouched();
      this.frmNewContractStartMonth.get('newContractStartMonth').markAsDirty();
    }
    return this.frmNewContractStartMonth.valid ? null : { valid: false, message: 'New Contract Start Month Invalid' };
  }

  registerOnValidatorChange?(fn: () => void): void {
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {

    } else {
      this.frmNewContractStartMonth.get('newContractStartMonth').enable();
    }
  }

  private setupForm(quote: QuotingModuleState): void {
    const newContractStartMonth = quote?.quoteConfiguration?.newContractStartMonth ?? '';
    const newContractStartMonthControl = new FormControl(newContractStartMonth, Validators.required);

    this.frmNewContractStartMonth = new FormGroup({
      newContractStartMonth: newContractStartMonthControl
    });
  }
}
